import Application from './app';
new Application().init();